import { render, staticRenderFns } from "./RWordCloud.vue?vue&type=template&id=d98a7fd2&scoped=true&"
import script from "./RWordCloud.vue?vue&type=script&lang=js&"
export * from "./RWordCloud.vue?vue&type=script&lang=js&"
import style0 from "./RWordCloud.vue?vue&type=style&index=0&id=d98a7fd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98a7fd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
